"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Element_1 = require("../../tree/Element");
const Utils_1 = require("../../tree/Utils");
const Patcher_1 = require("../Patcher");
class ChildList {
    constructor(obj) {
        this.element = obj;
        this.c = this.element.childList;
    }
    patch(settings) {
        if (Utils_1.Utils.isObjectLiteral(settings)) {
            this._setByObject(settings);
        }
        else if (Array.isArray(settings)) {
            this._setByArray(settings);
        }
    }
    getRefs() {
        return this.c.getRefs();
    }
    getIndex(item) {
        return this.c.getIndex(item);
    }
    add(item) {
        this.c.add(item);
    }
    setAt(item, index) {
        this.c.setAt(item, index);
    }
    _setByObject(settings) {
        // Overrule settings of known referenced items.
        const refs = this.getRefs();
        const crefs = Object.keys(settings);
        for (let i = 0, n = crefs.length; i < n; i++) {
            const cref = crefs[i];
            const s = settings[cref];
            let c = refs[cref];
            if (!c) {
                if (this.isItem(s)) {
                    // Replace previous item;
                    s.ref = cref;
                    this.add(s);
                }
                else {
                    // Create new item.
                    c = this.createItem(s);
                    c.ref = cref;
                    Patcher_1.Patcher.patchObject(c, s);
                    this.add(c);
                }
            }
            else {
                if (this.isItem(s)) {
                    if (c !== s) {
                        // Replace previous item;
                        const idx = this.getIndex(c);
                        s.ref = cref;
                        this.setAt(s, idx);
                    }
                }
                else {
                    Patcher_1.Patcher.patchObject(c, s);
                }
            }
        }
    }
    _equalsArray(array) {
        let same = true;
        const items = this.c.getItems();
        if (array.length === items.length) {
            for (let i = 0, n = items.length; i < n && same; i++) {
                same = same && items[i] === array[i];
            }
        }
        else {
            same = false;
        }
        return same;
    }
    _setByArray(array) {
        // For performance reasons, first check if the arrays match exactly and bail out if they do.
        if (this._equalsArray(array)) {
            return;
        }
        let refs;
        const newItems = [];
        for (let i = 0, n = array.length; i < n; i++) {
            const s = array[i];
            if (this.isItem(s)) {
                newItems.push(s);
            }
            else {
                const cref = s.ref;
                let c;
                if (cref) {
                    if (!refs)
                        refs = this.getRefs();
                    c = refs[cref];
                }
                if (!c) {
                    // Create new item.
                    c = this.createItem(s);
                }
                if (Utils_1.Utils.isObjectLiteral(s)) {
                    Patcher_1.Patcher.patchObject(c, s);
                }
                newItems.push(c);
            }
        }
        this.c.setItems(newItems);
    }
    createItem(object) {
        return Patcher_1.Patcher.createObject(object, Element_1.Element, this.element.stage);
    }
    isItem(object) {
        return object instanceof Element_1.Element;
    }
}
exports.ChildList = ChildList;
//# sourceMappingURL=ChildList.js.map